<template>
    <div>
        <!--General Top Bar -->
        <!-- <general-top-bar :title="$t('kds.report')" class="mar-bt-0"></general-top-bar> -->
    </div>
</template>

<script>
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'

export default {
  components: {
    // GeneralTopBar
  }
}
</script>

<style>
.el-date-editor .el-range-separator {
  padding: 0 2px;
}
#outer-container .navButtons .card-content {
  padding-left: 0px;
}
.el-table .cell {
  height: 55px;
}
.pull-right.legend {
  margin-top: 15px;
  cursor: pointer;
  text-decoration: underline;
}
.info-text {
  font-size: 13px;
  font-weight: 400;
  color: #000;
  background-color: white;
  padding: 7px 10px;
  border-radius: 9px;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.1);
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Screens/Kds/KdsReport.vue